// extracted by mini-css-extract-plugin
export default {"errorPage":"error_errorPage__02GW8","errorImage":"error_errorImage__wz1gv"};